module.exports = __webpack_public_path__ + "img/banner_1.25a0adb8.png";